export const getSelectOptionLabel = (
  options,
  value,
  fallbackToValue = false
) => {
  if (!Array.isArray(options) || value == null) {
    return "";
  }

  if (typeof options[0] === "string") {
    return options.includes(value) ? value : fallbackToValue ? value : "";
  }

  const match = options.find((opt) => opt?.value === value);
  return match?.label ?? (fallbackToValue ? value : "");
};
